import { render } from "./UserPersonalSettings.vue?vue&type=template&id=2e420968&scoped=true&lang=true"
import script from "./UserPersonalSettings.vue?vue&type=script&lang=js"
export * from "./UserPersonalSettings.vue?vue&type=script&lang=js"

import "./UserPersonalSettings.vue?vue&type=style&index=0&id=2e420968&lang=css&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e420968"]])

export default __exports__